import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostData,
  type BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostError,
  type BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostResponse,
  bulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPost,
} from '../../generated';

export type BulkRefreshPdpsMutationVariables = BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostData['path'] &
  BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostData['body'];

export type BulkRefreshPdpsMutation = BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostResponse;

export const useBulkRefreshPdpsMutation = <
  TError = BulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<BulkRefreshPdpsMutation, TError, BulkRefreshPdpsMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<BulkRefreshPdpsMutation, TError, BulkRefreshPdpsMutationVariables, TContext>({
    mutationKey: ['BulkRefreshPdps'],
    mutationFn: async ({ workspace_id, ...body }: BulkRefreshPdpsMutationVariables) => {
      const { data } = await bulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPost({
        path: { workspace_id },
        body,
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useBulkRefreshPdpsMutation.fetcher = (
  { workspace_id, ...body }: BulkRefreshPdpsMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await bulkRefreshPdpsV1WorkspacesWorkspaceIdBulkRefreshPost({
      path: { workspace_id },
      body,
      throwOnError: true,
    });
    return data;
  };
};
